"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var utils_1 = require("./utils");
var TweekValues_1 = require("./TweekValues");
exports.createWithTweekValues = function (TweekContext, prepare) {
    return function (valuesMapping, _a) {
        var _b = _a === void 0 ? {} : _a, defaultValues = _b.defaultValues, staticResetOnRepoChange = _b.resetOnRepoChange;
        Object.values(valuesMapping).forEach(function (key) { return prepare(key); });
        return function (BaseComponent) {
            var EnhancedComponent = function (_a) {
                var _b = _a.resetOnRepoChange, resetOnRepoChange = _b === void 0 ? staticResetOnRepoChange : _b, props = __rest(_a, ["resetOnRepoChange"]);
                return (react_1.default.createElement(TweekContext.Consumer, null, function (repo) { return (react_1.default.createElement(TweekValues_1.TweekValues, { tweekRepository: repo, valuesMapping: valuesMapping, defaultValues: defaultValues, resetOnRepoChange: resetOnRepoChange }, function (values) {
                    return react_1.default.createElement(BaseComponent, __assign({}, props, values));
                })); }));
            };
            EnhancedComponent.displayName = "withTweekValues(" + utils_1.getDisplayName(BaseComponent) + ")";
            return EnhancedComponent;
        };
    };
};
//# sourceMappingURL=createWithTweekValues.js.map


// WEBPACK FOOTER //
// ../src/createWithTweekValues.tsx